require('./mb-pdf-renderer.scss');

// vendors
import React, { useEffect, useState, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

import { LoadingSection } from 'commonsComponents/loadingSection';
import { isIosWebView } from '../../../utilities/migration.utils';
import { LOADER_WIDTH } from '../../../migrationUsersBranchView.constants';

export const FILE_FORMAT = {
  URL: 'url',
  BASE64: 'base64',
  BLOB: 'blob',
};

export const PDF_DOC_TYPE = {
  NORMAL: 'NORMAL',
  MODALVIWER: 'MODALVIWER',
};

const PDF_CONTENT_TYPE = 'application/pdf';

const readBlob = (blob, callback) => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onloadend = () => callback(reader.result);
};

const MbPdfRenderer = props => {
  const {
    file,
    fileFormat,
    lastPageNumber,
    onLoadSuccess,
    width,
    height,
    scale,
    setTotalPage,
    setCurrentPage,
    docTypeViewer,
    showToolBar,
  } = props;
  const [content, setContent] = useState(null);
  const [numPages, setNumPages] = useState(0);
  const documentRef = useRef(null);

  useEffect(() => {
    if (fileFormat == FILE_FORMAT.BLOB && file instanceof Blob) {
      readBlob(file, setContent);
    } else if (fileFormat === FILE_FORMAT.BASE64 && typeof file === 'string') {
      setContent(`data:${PDF_CONTENT_TYPE};base64, ${file}`);
    } else {
      setContent(file);
    }
  }, [width]);

  const onPdfLoaded = async pdfLoaded => {
    setNumPages(pdfLoaded.numPages);
    setTotalPage && setTotalPage(pdfLoaded.numPages);
    if (onLoadSuccess && onLoadSuccess.length === 1) {
      onLoadSuccess(await pdfLoaded.getData());
    } else {
      onLoadSuccess?.();
    }
  };

  const showCurrentPage = e => {
    const page = e.target.closest('.mb-pdf-page').getAttribute('data-page-number');
    setCurrentPage && setCurrentPage(page);
  };

  /* eslint-disable-next-line no-unused-vars */
  const onPageRenderSuccess = _page => {
    if (isIosWebView() && documentRef?.current) {
      documentRef.current.style.display = 'unset';
      setTimeout(() => {
        documentRef.current.style.display = 'block';
      }, 300);
    }
  };
  return (
    <div>
      {content && (
        <Document
          file={content}
          onLoadSuccess={onPdfLoaded}
          loading={<LoadingSection type="round" width={LOADER_WIDTH} />}
          className={'mb-pdf-document'}
        >
          <div className="mb-pdf-renderer-page-content">
            {Array.from({ length: lastPageNumber || numPages }, (val, index) => index + 1).map(
              page => (
                <Page
                  pageNumber={page}
                  key={page}
                  width={width}
                  height={height}
                  className={'mb-pdf-page'}
                  onMouseOver={docTypeViewer === PDF_DOC_TYPE.MODALVIWER && showCurrentPage}
                  renderAnnotationLayer={false}
                  canvasRef={documentRef}
                  onRenderSuccess={onPageRenderSuccess}
                  scale={scale}
                />
              )
            )}
          </div>
        </Document>
      )}
    </div>
  );
};

MbPdfRenderer.defaultProps = {
  showOverlay: false,
};

export default MbPdfRenderer;
